import Marquee from "react-fast-marquee";

const WORDS = ["Timber", "Carpet", "Tile", "Stone", "Drummoyne", "Curated", "Considered"];

export default function EditorialMarquee() {
  return (
    <section className="bg-[#121315] py-16 md:py-24 border-y border-[#8C7355]/15 overflow-hidden cv-auto">
      <Marquee speed={28} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-10 md:mx-16 inline-flex items-center gap-10 md:gap-16">
            <span className="font-serif-display italic font-light text-[#D6D1CA] text-5xl md:text-7xl">{w}</span>
            <span className="w-2 h-2 rounded-full bg-[#8C7355]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
